import type { CriteriaRoot } from './types';

function isEmptyField(field: unknown): boolean {
  return field == null || String(field).trim() === '';
}

/** Legacy: hide delete when single rule and first rule field is still empty. */
export function shouldShowRuleDelete(
  criteria: CriteriaRoot,
  groupIndex: number,
  ruleIndex: number,
): boolean {
  const rules = criteria.Conditions[groupIndex]?.SubCriteria?.Conditions ?? [];
  if (rules.length === 0) return false;

  const firstField = rules[0]?.Field;
  if (rules.length === 1 && isEmptyField(firstField)) {
    return false;
  }

  return ruleIndex >= 0 && ruleIndex < rules.length;
}
